"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeSearchTypeOptions = exports.KnowledgeSourceOptions = exports.GCSelectOptions = exports.ActionStartOptions = exports.HubOptions = exports.HubTypes = exports.TeamsAppValidationOptions = exports.recommendedLocations = exports.CustomCopilotAssistantOptions = exports.CustomCopilotRagOptions = exports.SPFxVersionOptionIds = exports.NotificationTriggerOptions = exports.NotificationTriggers = exports.HostType = exports.MeArchitectureOptions = exports.AddAuthActionAuthTypeOptions = exports.ApiAuthOptions = exports.ScratchOptions = exports.capabilitiesHavePythonOption = exports.DeclarativeAgentApiSpecOptionId = exports.ProgrammingLanguage = exports.MAX_EMAIL_NUMBER = exports.CliQuestionName = exports.AppNamePattern = exports.QuestionNames = void 0;
const featureFlags_1 = require("../common/featureFlags");
const localizeUtils_1 = require("../common/localizeUtils");
var questionNames_1 = require("./questionNames");
Object.defineProperty(exports, "QuestionNames", { enumerable: true, get: function () { return questionNames_1.QuestionNames; } });
exports.AppNamePattern = '^(?=(.*[\\da-zA-Z]){2})[a-zA-Z][^"<>:\\?/*&|\u0000-\u001F]*[^"\\s.<>:\\?/*&|\u0000-\u001F]$';
var CliQuestionName;
(function (CliQuestionName) {
    CliQuestionName["Capability"] = "capability";
})(CliQuestionName = exports.CliQuestionName || (exports.CliQuestionName = {}));
exports.MAX_EMAIL_NUMBER = 20;
var ProgrammingLanguage;
(function (ProgrammingLanguage) {
    ProgrammingLanguage["JS"] = "javascript";
    ProgrammingLanguage["TS"] = "typescript";
    ProgrammingLanguage["CSharp"] = "csharp";
    ProgrammingLanguage["PY"] = "python";
    ProgrammingLanguage["Common"] = "common";
    ProgrammingLanguage["None"] = "none";
})(ProgrammingLanguage = exports.ProgrammingLanguage || (exports.ProgrammingLanguage = {}));
exports.DeclarativeAgentApiSpecOptionId = "api-spec";
exports.capabilitiesHavePythonOption = [
    "custom-copilot-basic",
    "custom-copilot-rag-azureAISearch",
    "custom-copilot-rag-customize",
    "custom-copilot-agent-new",
    "custom-copilot-agent-assistants-api",
    "custom-copilot-rag-customApi",
];
class ScratchOptions {
    static yes() {
        return {
            id: "yes",
            label: (0, localizeUtils_1.getLocalizedString)("core.ScratchOptionYes.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.ScratchOptionYes.detail"),
        };
    }
    static no() {
        return {
            id: "no",
            label: (0, localizeUtils_1.getLocalizedString)("core.ScratchOptionNo.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.ScratchOptionNo.detail"),
        };
    }
    static all() {
        return [ScratchOptions.yes(), ScratchOptions.no()];
    }
}
exports.ScratchOptions = ScratchOptions;
class ApiAuthOptions {
    static none() {
        return {
            id: "none",
            label: "None",
        };
    }
    static apiKey() {
        return {
            id: "api-key",
            label: "API Key",
        };
    }
    static bearerToken() {
        return {
            id: "bearer-token",
            label: "API Key (Bearer Token Auth)",
        };
    }
    static microsoftEntra() {
        return {
            id: "microsoft-entra",
            label: "Microsoft Entra",
        };
    }
    static oauth() {
        return {
            id: "oauth",
            label: "OAuth",
        };
    }
    static all() {
        return [
            ApiAuthOptions.none(),
            ApiAuthOptions.apiKey(),
            ApiAuthOptions.bearerToken(),
            ApiAuthOptions.microsoftEntra(),
            ApiAuthOptions.oauth(),
        ];
    }
}
exports.ApiAuthOptions = ApiAuthOptions;
class AddAuthActionAuthTypeOptions {
    static apiKey() {
        return {
            id: "api-key",
            label: "API Key",
        };
    }
    static bearerToken() {
        return {
            id: "bearer-token",
            label: "API Key (Bearer Token Auth)",
        };
    }
    static oauth() {
        return {
            id: "oauth",
            label: "OAuth",
        };
    }
    static microsoftEntra() {
        return {
            id: "microsoft-entra",
            label: "Microsoft Entra",
        };
    }
    static all() {
        return [
            AddAuthActionAuthTypeOptions.bearerToken(),
            AddAuthActionAuthTypeOptions.apiKey(),
            AddAuthActionAuthTypeOptions.oauth(),
            AddAuthActionAuthTypeOptions.microsoftEntra(),
        ];
    }
}
exports.AddAuthActionAuthTypeOptions = AddAuthActionAuthTypeOptions;
class MeArchitectureOptions {
    static botMe() {
        return {
            id: "bot",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.botMessageExtension.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.botMessageExtension.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlook"),
        };
    }
    static newApi() {
        return {
            id: "new-api",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginNewApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.messageExtensionNewApiOption.detail"),
        };
    }
    static apiSpec() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.messageExtensionApiSpecOption.detail"),
        };
    }
    static all() {
        return [
            MeArchitectureOptions.newApi(),
            MeArchitectureOptions.apiSpec(),
            MeArchitectureOptions.botMe(),
        ];
    }
    static staticAll() {
        return [
            MeArchitectureOptions.newApi(),
            MeArchitectureOptions.apiSpec(),
            MeArchitectureOptions.botMe(),
        ];
    }
}
exports.MeArchitectureOptions = MeArchitectureOptions;
var HostType;
(function (HostType) {
    HostType["AppService"] = "app-service";
    HostType["Functions"] = "azure-functions";
})(HostType = exports.HostType || (exports.HostType = {}));
exports.NotificationTriggers = {
    HTTP: "http",
    TIMER: "timer",
};
class NotificationTriggerOptions {
    static appService() {
        return {
            id: "http-express",
            hostType: HostType.AppService,
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.detail"),
        };
    }
    static appServiceForVS() {
        return {
            id: "http-webapi",
            hostType: HostType.AppService,
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.detail"),
        };
    }
    // NOTE: id must be the sample as cliName to prevent parsing error for CLI default value.
    static functionsTimerTrigger() {
        return {
            id: "timer-functions",
            hostType: HostType.Functions,
            triggers: [exports.NotificationTriggers.TIMER],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.detail"),
        };
    }
    static functionsHttpAndTimerTrigger() {
        return {
            id: "http-and-timer-functions",
            hostType: HostType.Functions,
            triggers: [exports.NotificationTriggers.HTTP, exports.NotificationTriggers.TIMER],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.detail"),
        };
    }
    static functionsHttpTrigger() {
        return {
            id: "http-functions",
            hostType: HostType.Functions,
            triggers: [exports.NotificationTriggers.HTTP],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.detail"),
        };
    }
    static functionsTriggers() {
        return [
            NotificationTriggerOptions.functionsHttpAndTimerTrigger(),
            NotificationTriggerOptions.functionsHttpTrigger(),
            NotificationTriggerOptions.functionsTimerTrigger(),
        ];
    }
    static all() {
        return [
            NotificationTriggerOptions.appService(),
            NotificationTriggerOptions.appServiceForVS(),
            NotificationTriggerOptions.functionsHttpAndTimerTrigger(),
            NotificationTriggerOptions.functionsHttpTrigger(),
            NotificationTriggerOptions.functionsTimerTrigger(),
        ];
    }
}
exports.NotificationTriggerOptions = NotificationTriggerOptions;
var SPFxVersionOptionIds;
(function (SPFxVersionOptionIds) {
    SPFxVersionOptionIds["installLocally"] = "true";
    SPFxVersionOptionIds["globalPackage"] = "false";
})(SPFxVersionOptionIds = exports.SPFxVersionOptionIds || (exports.SPFxVersionOptionIds = {}));
class CustomCopilotRagOptions {
    static customize() {
        return {
            id: "custom-copilot-rag-customize",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomizeOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomizeOption.detail"),
        };
    }
    static azureAISearch() {
        return {
            id: "custom-copilot-rag-azureAISearch",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagAzureAISearchOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagAzureAISearchOption.detail"),
        };
    }
    static customApi() {
        return {
            id: "custom-copilot-rag-customApi",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagCustomApiOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
        };
    }
    static microsoft365() {
        return {
            id: "custom-copilot-rag-microsoft365",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagMicrosoft365Option.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagMicrosoft365Option.detail"),
        };
    }
    static all() {
        return [
            CustomCopilotRagOptions.customize(),
            CustomCopilotRagOptions.azureAISearch(),
            CustomCopilotRagOptions.customApi(),
            CustomCopilotRagOptions.microsoft365(),
        ];
    }
}
exports.CustomCopilotRagOptions = CustomCopilotRagOptions;
class CustomCopilotAssistantOptions {
    static new() {
        return {
            id: "custom-copilot-agent-new",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantNewOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantNewOption.detail"),
        };
    }
    static assistantsApi() {
        return {
            id: "custom-copilot-agent-assistants-api",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantAssistantsApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantAssistantsApiOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
        };
    }
    static all() {
        return [CustomCopilotAssistantOptions.new(), CustomCopilotAssistantOptions.assistantsApi()];
    }
}
exports.CustomCopilotAssistantOptions = CustomCopilotAssistantOptions;
exports.recommendedLocations = [
    "South Africa North",
    "Australia East",
    "Central India",
    "East Asia",
    "Japan East",
    "Korea Central",
    "Southeast Asia",
    "Canada Central",
    "France Central",
    "Germany West Central",
    "Italy North",
    "North Europe",
    "Norway East",
    "Poland Central",
    "Sweden Central",
    "Switzerland North",
    "UK South",
    "West Europe",
    "Israel Central",
    "Qatar Central",
    "UAE North",
    "Brazil South",
    "Central US",
    "East US",
    "East US 2",
    "South Central US",
    "West US 2",
    "West US 3",
];
class TeamsAppValidationOptions {
    static schema() {
        return {
            id: "validateAgainstSchema",
            label: (0, localizeUtils_1.getLocalizedString)("core.selectValidateMethodQuestion.validate.schemaOption"),
        };
    }
    static package() {
        return {
            id: "validateAgainstPackage",
            label: (0, localizeUtils_1.getLocalizedString)("core.selectValidateMethodQuestion.validate.appPackageOption"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.selectValidateMethodQuestion.validate.appPackageOptionDescription"),
        };
    }
    static testCases() {
        return {
            id: "validateWithTestCases",
            label: (0, localizeUtils_1.getLocalizedString)("core.selectValidateMethodQuestion.validate.testCasesOption"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.selectValidateMethodQuestion.validate.testCasesOptionDescription"),
        };
    }
}
exports.TeamsAppValidationOptions = TeamsAppValidationOptions;
var HubTypes;
(function (HubTypes) {
    HubTypes["teams"] = "teams";
    HubTypes["outlook"] = "outlook";
    HubTypes["office"] = "office";
})(HubTypes = exports.HubTypes || (exports.HubTypes = {}));
class HubOptions {
    static teams() {
        return {
            id: "teams",
            label: "Teams",
        };
    }
    static outlook() {
        return {
            id: "outlook",
            label: "Outlook",
        };
    }
    static office() {
        return {
            id: "office",
            label: "the Microsoft 365 app",
        };
    }
    static all() {
        return [this.teams(), this.outlook(), this.office()];
    }
}
exports.HubOptions = HubOptions;
class ActionStartOptions {
    static newApi() {
        return {
            id: "new-api",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginNewApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginNewApiOption.detail"),
        };
    }
    static apiSpec() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.copilotPluginApiSpecOption.detail"),
        };
    }
    static existingPlugin() {
        return {
            id: "existing-plugin",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.importPlugin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.importPlugin.detail"),
        };
    }
    static staticAll(doesProjectExists) {
        return doesProjectExists
            ? [ActionStartOptions.apiSpec()]
            : [ActionStartOptions.newApi(), ActionStartOptions.apiSpec()];
    }
    static all(inputs, doesProjectExists) {
        if (doesProjectExists) {
            return [ActionStartOptions.apiSpec()];
        }
        else {
            // use constant string to avoid cycle dependency
            return [ActionStartOptions.newApi(), ActionStartOptions.apiSpec()];
        }
    }
}
exports.ActionStartOptions = ActionStartOptions;
class GCSelectOptions {
    static list() {
        return {
            id: "listConnections",
            label: (0, localizeUtils_1.getLocalizedString)("core.GCSelectOptions.listOption.title"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.GCSelectOptions.listOption.description"),
        };
    }
    static input() {
        return {
            id: "inputConnectionId",
            label: (0, localizeUtils_1.getLocalizedString)("core.GCSelectOptions.inputOption.title"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.GCSelectOptions.inputOption.description"),
            data: "https://aka.ms/teamsfx-graph-connector-id",
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.tutorial"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
    }
}
exports.GCSelectOptions = GCSelectOptions;
class KnowledgeSourceOptions {
    static webSearch() {
        return {
            id: "web-search",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeWebSearch.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeWebSearch.detail"),
        };
    }
    static oneDriveSharePoint() {
        return {
            id: "oneDrive-sharePoint",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeOneDriveSharePoint.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeOneDriveSharePoint.detail"),
        };
    }
    static graphConnector() {
        return {
            id: "graph-connector",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeGraphConnector.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeGraphConnector.detail"),
        };
    }
    static embeddedKnowledge() {
        return {
            id: "embedded-knowledge",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeEmbeddedKnowledge.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.knowledgeEmbeddedKnowledge.detail"),
        };
    }
    static all() {
        const items = [
            KnowledgeSourceOptions.webSearch(),
            KnowledgeSourceOptions.oneDriveSharePoint(),
            KnowledgeSourceOptions.graphConnector(),
            KnowledgeSourceOptions.embeddedKnowledge(),
        ];
        return items;
    }
    static allWithFeatureFlags() {
        const items = [
            KnowledgeSourceOptions.webSearch(),
            ...(featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.AddODSPKnowledge)
                ? [KnowledgeSourceOptions.oneDriveSharePoint()]
                : []),
            KnowledgeSourceOptions.graphConnector(),
        ];
        if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.EmbeddedKnowledgeEnabled)) {
            items.push(KnowledgeSourceOptions.embeddedKnowledge());
        }
        return items;
    }
}
exports.KnowledgeSourceOptions = KnowledgeSourceOptions;
class KnowledgeSearchTypeOptions {
    static url() {
        return {
            id: "url",
            label: (0, localizeUtils_1.getLocalizedString)("core.addKnowledgeQuestion.searchType.url"),
        };
    }
    static allWeb() {
        return {
            id: "all-web",
            label: (0, localizeUtils_1.getLocalizedString)("core.addKnowledgeQuestion.searchType.web"),
        };
    }
    static allOneDriveSharepoint() {
        return {
            id: "all-oneDrive-sharePoint",
            label: (0, localizeUtils_1.getLocalizedString)("core.addKnowledgeQuestion.searchType.oneDriveSharepoint"),
        };
    }
    static all() {
        const items = [
            KnowledgeSearchTypeOptions.url(),
            KnowledgeSearchTypeOptions.allWeb(),
            KnowledgeSearchTypeOptions.allOneDriveSharepoint(),
        ];
        return items;
    }
}
exports.KnowledgeSearchTypeOptions = KnowledgeSearchTypeOptions;
//# sourceMappingURL=constants.js.map